import {IDomainCategoryDescription} from '../state/global.types';
import {APIService} from '@/services/api.service';
import {FilterTag} from '@/views/amex/app-types';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';

export const mapFilterToFilterTag = (x: IDomainCategoryDescription): FilterTag => {
  return {
    id: x.id,
    name: x.name,
    domain: x.category,
    domainSection: x.source,
    parent: x.parent,
    value: false,
  };
};

export async function downloadDomains(context = ''): Promise<FilterTag[]> {
  try {
    const {domain} = await APIService.get<{domain: IDomainCategoryDescription[]}>(`profile/domain`, {
      params: {
        mode: process.env.VUE_APP_MODE,
        context,
      },
    });
    return domain
      .filter(
        (x) =>
          [
            UserActivityCategoryEnum.ACCOMMODATION,
            UserActivityCategoryEnum.DINING,
            UserActivityCategoryEnum.EXPERIENCE,
            UserActivityCategoryEnum.GEOLOCATION,
            UserActivityCategoryEnum.TRANSPORTATION,
            UserActivityCategoryEnum.BUDGET,
            UserActivityCategoryEnum.TIMEFRAME,
            UserActivityCategoryEnum.TRIPPREFERENCE,
          ].indexOf(x.category) >= 0,
      )
      .map(mapFilterToFilterTag);
  } catch (e) {
    return [];
  }
}
